import { TypedSopNode } from "./_Base";
import { InputCloneMode } from "../../poly/InputCloneMode";
import { ScatterSopOperation } from "../../operations/sop/Scatter";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
const DEFAULT = ScatterSopOperation.DEFAULT_PARAMS;
class ScatterSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.pointsCount = ParamConfig.INTEGER(DEFAULT.pointsCount, {
      range: [0, 1e3],
      rangeLocked: [true, false]
    });
    this.seed = ParamConfig.INTEGER(DEFAULT.seed, {
      range: [0, 100],
      rangeLocked: [true, false]
    });
    this.useWeightAttribute = ParamConfig.BOOLEAN(DEFAULT.useWeightAttribute);
    this.weightAttribute = ParamConfig.STRING(DEFAULT.weightAttribute, {
      visibleIf: { useWeightAttribute: 1 }
    });
    this.transferAttributes = ParamConfig.BOOLEAN(DEFAULT.transferAttributes);
    this.attributesToTransfer = ParamConfig.STRING(DEFAULT.attributesToTransfer, {
      visibleIf: { transferAttributes: 1 }
    });
    this.addIdAttribute = ParamConfig.BOOLEAN(DEFAULT.addIdAttribute);
    this.addIdnAttribute = ParamConfig.BOOLEAN(DEFAULT.addIdnAttribute);
  }
}
const ParamsConfig = new ScatterSopParamsConfig();
export class ScatterSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "scatter";
  }
  static displayedInputNames() {
    return ["geometry to scatter points onto"];
  }
  initializeNode() {
    this.io.inputs.setCount(1);
    this.io.inputs.initInputsClonedState(InputCloneMode.NEVER);
  }
  async cook(inputCoreGroups) {
    this._operation = this._operation || new ScatterSopOperation(this.scene(), this.states, this);
    const coreGroup = await this._operation.cook(inputCoreGroups, this.pv);
    this.setCoreGroup(coreGroup);
  }
}
